import Swiper from 'swiper';

document.addEventListener('click', (e) => {
    if (e.target.matches('[data-js="addons-show-all"]')) {
        const slides = e.target.parentNode.querySelectorAll('.swiper-slide');
        slides.forEach(slide => slide.style.display = 'block');
        
        e.target.classList.replace('visible-xs', 'hidden-xs');
        e.target.classList.replace('visible-sm', 'hidden-sm');
    }
});

const elements = document.querySelectorAll('#addons-carousel');

if (elements.length) {
    elements.forEach(element => {
        const swiper = new Swiper(element, {
            passiveListeners: false,
            slidesPerView: 2.4,
            speed: 1500,
            watchOverflow: true,
            spaceBetween: 15,
            init: false,
            navigation: {
                nextEl: element.parentNode.querySelector('.swiper-navigation-next'),
                prevEl: element.parentNode.querySelector('.swiper-navigation-prev'),
            }
        });

        if (window.innerWidth > 992) {
            swiper.init();
        } else {
            const slides = element.querySelectorAll('.swiper-slide');
            const showAllButton = element.parentNode.querySelector('[data-js="addons-show-all"]');
    
            if (slides.length <= 2 && showAllButton) {
                // showAllButton.style.display = 'none';
                showAllButton.classList.replace('visible-xs', 'hidden-xs');
                showAllButton.classList.replace('visible-sm', 'hidden-sm');
            }
        }
    });
}
